import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import PredictionSteps from "./PredictionSteps";

export interface IPredictPageProps extends RouteComponentProps<any> {}

export default class PredictPage extends React.Component<
  IPredictPageProps,
  {}
> {
  constructor(props: IPredictPageProps) {
    super(props);
  }

  public render() {
    return (
      <div>
        <PredictionSteps initialState={this.props.location.state} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PredictionPage/PredictPage.tsx